import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Content, Split, SplitItem, TextInputGroup, TextInputGroupMain } from '@patternfly/react-core';
import { PlusIcon, TrashIcon } from '@patternfly/react-icons';
import { useRef, useState } from 'react';
import { getCamelRandomId } from '../utils/camel-random-id';
import { KeyValueField } from './KeyValueField';
export const KeyValue = ({ propName, initialModel, onChange, disabled = false }) => {
    const [internalModel, setInternalModel] = useState(Object.entries(initialModel !== null && initialModel !== void 0 ? initialModel : {}));
    const currentFocusIndex = useRef(['key', -1]);
    const getFocusRefFn = (location, index) => (inputElement) => {
        if (inputElement && location === currentFocusIndex.current[0] && index === currentFocusIndex.current[1]) {
            inputElement.focus();
        }
    };
    const updateModel = (newModel) => {
        setInternalModel(newModel);
        onChange(Object.fromEntries(newModel));
    };
    const onAddNewProperty = () => {
        const newKey = getCamelRandomId('key', 4);
        const newKeyValue = [newKey, ''];
        const newModel = [...internalModel, newKeyValue];
        currentFocusIndex.current = ['key', internalModel.length];
        updateModel(newModel);
    };
    const onRemoveProperty = (key) => {
        const newModel = internalModel.filter(([k]) => k !== key);
        updateModel(newModel);
    };
    const onPropertyKeyChange = (key, newKey) => {
        const newModel = internalModel.map(([k, v]) => (k === key ? [newKey, v] : [k, v]));
        updateModel(newModel);
    };
    const onPropertyValueChange = (key, newValue) => {
        const newModel = internalModel.map(([k, v]) => (k === key ? [k, newValue] : [k, v]));
        updateModel(newModel);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Split, { hasGutter: true, children: [_jsx(SplitItem, { isFilled: true, children: "Key" }), _jsx(SplitItem, { isFilled: true, children: "Value" }), _jsx(SplitItem, { children: _jsx(Button, { variant: "plain", "data-testid": `${propName}__add`, onClick: onAddNewProperty, "aria-label": "Add a new property", title: "Add a new property", icon: _jsx(PlusIcon, {}), isDisabled: disabled }) })] }), _jsx(Content, { component: "hr" }), internalModel.map(([key, value], index) => {
                return (_jsxs(Split, { hasGutter: true, children: [_jsx(SplitItem, { isFilled: true, children: _jsx(TextInputGroup, { children: _jsx(TextInputGroupMain, { type: "text", id: `${propName}__${key}__key`, name: `${propName}__${key}__key`, "data-testid": `${propName}__key`, onChange: (_event, value) => {
                                        onPropertyKeyChange(key, value);
                                    }, ref: getFocusRefFn('key', index), onFocus: () => {
                                        currentFocusIndex.current = ['key', index];
                                    }, onBlur: () => {
                                        currentFocusIndex.current = ['key', -1];
                                    }, placeholder: "Write a key", value: key }) }) }), _jsx(SplitItem, { isFilled: true, children: _jsx(KeyValueField, { id: `${propName}__${key}__value`, name: `${propName}__${key}__value`, "data-testid": `${propName}__value`, onChange: (value) => {
                                    onPropertyValueChange(key, value);
                                }, ref: getFocusRefFn('value', index), onFocus: () => {
                                    currentFocusIndex.current = ['value', index];
                                }, onBlur: () => {
                                    currentFocusIndex.current = ['value', -1];
                                }, placeholder: "Write a value", value: value }) }), _jsx(SplitItem, { children: _jsx(Button, { variant: "plain", "data-testid": `${propName}__remove__${key}`, onClick: () => {
                                    onRemoveProperty(key);
                                }, "aria-label": `Remove the ${key} property`, title: `Remove the ${key} property`, icon: _jsx(TrashIcon, {}) }) })] }, index));
            })] }));
};
//# sourceMappingURL=KeyValue.js.map